import { useTranslatedValue } from '../../../../common/translation'
import {
  type PublicCompanyBranch,
} from '..'

/**
 * returns company branch name (if not defined, we use the parent company name)
 */
export const useCompanyBranchName = (companyBranch?: Pick<PublicCompanyBranch, 'identification' | 'company'>) => {
  const getTranslation = useTranslatedValue()

  return getTranslation(companyBranch?.identification?.name) ??
  getTranslation(companyBranch?.company?.identification.name)
}
